/** A byte count as megabytes, as the page shows a workbook's size. */
export const formatSize = (bytes: number) => `${(bytes / 1024 / 1024).toFixed(1)} MB`
